<template>
  <div class="">
    <!-- Título principal -->
    <div class="my-6">
      <h1 class="text-2xl font-bold text-gray-800 mb-2">
        Integración con webHooks
      </h1>
    </div>

    <!-- Layout en dos columnas sin v-row -->
    <div class="grid grid-cols-2 xl:grid-cols-2 gap-6 xl:gap-8">
      <!-- Columna izquierda - Documentación -->
      <div class="space-y-4 xl:space-y-6">
        <!-- Información del endpoint -->
        <div class="bg-white rounded-lg border border-gray-200 p-4 xl:p-6">
          <h3 class="text-lg xl:text-xl font-semibold flex items-center">
            <span class="bg-blue-100 text-blue-800 px-2 py-1 rounded text-sm xl:text-base font-mono mr-3">POST</span>
            https://sb-wee.ar/v1/webhooks
          </h3>
        </div>

        <p>
          Debe implementar un EndPoint método post que pueda recibir un JSON con
          la siguiente estructura:
        </p>
        <!-- Parámetros -->
        <h4 class="font-semibold mb-3 xl:mb-4 text-base xl:text-lg">
          Request
        </h4>

        <!-- Headers Table -->
        <DynamicTable title="Headers" :headers="headersWebhooks" :data="headersData" height="150px" />

        <!-- Response -->
        <h4 class="font-semibold mb-3 xl:mb-4 text-base xl:text-lg">
          Response
        </h4>

        <DynamicTable title="Atributos del objeto de la respuesta." :headers="responseHeaders" :data="responseData"
          height="auto" />

        <DynamicTable title="Atributos del objeto de data." :headers="responseHeadersData" :data="responseObjectData"
          height="150px" />

        <DynamicTable title="Atributos del objeto items." :headers="responseHeadersItems" :data="responseObjectItems"
          height="200px" />
      </div>

      <!-- Columna derecha - Ejemplos de código -->
      <div class="space-y-4 xl:space-y-6">
        <!-- Request Example -->

        <CodeBlock title="Example Request" :code="requestExample" language="json" status="success" :is-large="true"
          :request="true" />
      </div>
    </div>
    <!-- DIAGRAMA ESTADOS solicitud de pagos -->
    <div class="my-6">
      <h1 class="text-2xl font-bold text-gray-800 mb-2">
        Estados de una Solicitud de Pago
      </h1>
      <p>
        Los siguientes diagramas muestran la transicion de los diferentes
        estados:
      </p>
    </div>
    <div class="grid grid-cols-2 xl:grid-cols-2 gap-6 xl:gap-8 mb-4">
      <div>
        <!-- Credito y Debito -->
        <h5 class="text-lg xl:text-xl font-semibold flex items-center mb-2">
          Credito y Debito:
        </h5>
        <v-img class="rounded-lg border border-gray-200 bg-white" height="600" contain
          src="/assets/img/estado-credito-debito.png"></v-img>
      </div>
      <div>
        <!-- Offline -->
        <h5 class="text-lg xl:text-xl font-semibold flex items-center mb-2">
          Offline (RAPIPAGO Y MULTIPAGO):
        </h5>
        <v-img class="rounded-lg border border-gray-200 bg-white" height="600" contain
          src="/assets/img/estado-offline.webp"></v-img>
      </div>
    </div>
    <div class="grid grid-cols-2 xl:grid-cols-2 gap-6 xl:gap-8">
      <!-- Debin -->
      <div>
        <h5 class="text-lg xl:text-xl font-semibold flex items-center mb-2">
          Debin:
        </h5>
        <v-img class="rounded-lg border border-gray-200 bg-white" height="550" contain
          src="/assets/img/estado-debin.png" style="margin: 0 0 80px 0"></v-img>
      </div>
      <div>
        <!-- QR -->
        <h5 class="text-lg xl:text-xl font-semibold flex items-center mb-2">
          QR:
        </h5>
        <v-img class="rounded-lg border border-gray-200 bg-white" height="550" contain src="/assets/img/estado-qr.png"
          style="margin: 0 0 80px 0"></v-img>
      </div>
    </div>
  </div>
</template>
<script>
import DynamicTable from "../shared/DynamicTable.vue";
import CodeBlock from "../shared/CodeBlock.vue";

export default {
  name: "CrearSolicitudPago",
  components: {
    DynamicTable,
    CodeBlock,
  },
  data() {
    return {
      // Configuración de headers para la tabla de Headers
      headersWebhooks: [
        { key: "atributo", label: "atributo", isCode: true },
        { key: "tipo", label: "TIPO" },
        { key: "descripcion", label: "DESCRIPCIÓN" },
      ],

      // Datos de headers
      headersData: [
        {
          atributo: "id",
          tipo: "Integer",
          descripcion: "Identificador único de pago.",
        },
        {
          atributo: "estado_pago",
          tipo: "String",
          descripcion:
            "Estados posibles: PENDIENTE, PROCESANDO, RECHAZADO, APROBADO, REVERTIDO, CADUCADO, AUTORIZADO.",
        },
        {
          atributo: "Boolean",
          tipo: "Integer",
          descripcion: "Indica si el pago fue exitoso o no.",
        },
        {
          atributo: "channel",
          tipo: "String",
          descripcion: "Canal de pago.",
        },
        {
          atributo: "description",
          tipo: "String",
          descripcion: "Descripcion del pago.",
        },
        {
          atributo: "firstDueDate",
          tipo: "String",
          descripcion: "Fecha de 1º Vencimiento. Formato dd/mm/aaaa.",
        },
        {
          atributo: "first_total",
          tipo: "Float",
          descripcion: "Monto total antes de vencimiento.",
        },
        {
          atributo: "second_due_date",
          tipo: "String",
          descripcion: "Fecha de 2º Vencimiento. Formato dd/mm/aaaa.",
        },
        {
          atributo: "second_total",
          tipo: "Float",
          descripcion: "Monto total pasado el 1º vencimiento.",
        },
        {
          atributo: "payer_name",
          tipo: "String",
          descripcion: "Nombre del pagador.",
        },
        {
          atributo: "payer_email",
          tipo: "String",
          descripcion: "Correo electrónico del pagador.",
        },
        {
          atributo: "external_reference",
          tipo: "String",
          descripcion:
            "Este atributo se puede utilizar como referencia para identificar la solicitud de pago y sincronizar con tus sistemas de backend el origen de la operación.",
        },
        {
          atributo: "metadata",
          tipo: "String",
          descripcion: "Mas información del pago.",
        },

        {
          atributo: "barcode",
          tipo: "String",
          descripcion: "Código de barras solo para pagos offline.",
        },
        {
          atributo: "barcode_url",
          tipo: "String",
          descripcion: "URL del código de barras solo para pagos offline.",
        },
        {
          atributo: "pdf_url",
          tipo: "String",
          descripcion: "Comprobante de pago.",
        },
        {
          atributo: "created_at",
          tipo: "String",
          descripcion: "Fecha de creacion de la solicitud de pago.",
        },
        {
          atributo: "importe_pagado",
          tipo: "Float",
          descripcion: "Importe pagado.",
        },
      ],

      // Configuración de headers para la tabla de Body
      bodyConfig: [
        { key: "atributo", label: "ATRIBUTO", isCode: true },
        { key: "tipo", label: "TIPO" },
        { key: "requerido", label: "REQUERIDO" },
        { key: "descripcion", label: "DESCRIPCIÓN" },
      ],

      // Datos de parámetros del body
      bodyParameters: [
        {
          atributo: "payer_name",
          tipo: "String",
          requerido: "Sí",
          descripcion: "Nombre del pagador.",
        },
        {
          atributo: "payer_type",
          tipo: "String",
          requerido: "No",
          descripcion: "Tipo de identificación (DNI o CUIL) del pagador.",
        },
        {
          atributo: "payer_number",
          tipo: "String",
          requerido: "No",
          descripcion: "Número de identificación del pagador.",
        },
        {
          atributo: "payer_email",
          tipo: "String",
          requerido: "Sí",
          descripcion: "Correo electrónico del pagador.",
        },
        {
          atributo: "description",
          tipo: "String",
          requerido: "Sí",
          descripcion: "Descripción de la solicitud de pago.",
        },
        {
          atributo: "first_total",
          tipo: "Integer",
          requerido: "Si",
          descripcion:
            "Monto total antes de vencimiento. Valor entero. Los dos últimos dígitos se consideran decimales.",
        },
        {
          atributo: "first_due_date",
          tipo: "String",
          requerido: "Si",
          descripcion: "Fecha de 1º Vencimiento. Formato dd/mm/aaaa.",
        },
        {
          atributo: "external_reference",
          tipo: "String o Integer",
          requerido: "Si",
          descripcion:
            "Este atributo se puede utilizar como referencia para identificar la solicitud de pago y sincronizar con tus sistemas de backend el origen de la operación.",
        },
        {
          atributo: "second_total",
          tipo: "Integer",
          requerido: "No",
          descripcion:
            "Monto total, valor entero. Los dos últimos dígitos se consideran decimales. Este valor se incluye solamente si existe fecha de 2º vencimiento.",
        },
        {
          atributo: "second_due_date",
          tipo: "String",
          requerido: "No",
          descripcion: "Fecha de 2º Vencimiento. Formato dd/mm/aaaa.",
        },
        {
          atributo: "payment_type",
          tipo: "String",
          requerido: "Si",
          descripcion: "Tipificación del cobro.",
        },
        {
          atributo: "items",
          tipo: "Array [Object]",
          requerido: "Si",
          descripcion: "Lista detallada de productos o servicios.",
        },
        {
          atributo: "notificacion_url",
          tipo: "String",
          requerido: "No",
          descripcion:
            "Url donde se va a notificar el pago, en caso de que el cliente tenga activado webhook dinámico.o",
        },
        {
          atributo: "redireccion_url_success",
          tipo: "String",
          requerido: "No",
          descripcion:
            "Url de redirección dinámica cuando el pago finaliza de forma exitosa/aprobada.",
        },
        {
          atributo: "redireccion_url_pending",
          tipo: "String",
          requerido: "No",

          descripcion:
            "Url de redirección dinámica cuando el pago finaliza de forma exitosa/pendiente.",
        },
      ],

      itemsBody: [
        { key: "atributo", label: "ATRIBUTO", isCode: true },
        { key: "tipo", label: "TIPO" },
        { key: "requerido", label: "REQUERIDO" },
        { key: "descripcion", label: "DESCRIPCIÓN" },
      ],

      itemsData: [
        {
          atributo: "quantity",
          tipo: "Integer",
          requerido: "Sí",
          descripcion: "Cantidad del producto o servicio.",
        },
        {
          atributo: "description",
          tipo: "String",
          requerido: "Sí",
          descripcion: "Descripción del producto o servicio.",
        },
        {
          atributo: "amount",
          tipo: "Integer",
          requerido: "Sí",
          descripcion: "Importe del producto o servicio.",
        },
        {
          atributo: "identifier",
          tipo: "String",
          requerido: "No",
          descripcion: "Identificador del producto o servicio.",
        },
      ],

      // Response

      responseHeaders: [
        { key: "atributo", label: "atributo", isCode: true },
        { key: "tipo", label: "TIPO" },
        { key: "descripcion", label: "DESCRIPCIÓN" },
      ],

      responseData: [
        {
          atributo: "data",
          tipo: "Object",
          descripcion: "Objeto con la información de la solicitud de pago.",
        },
        {
          atributo: "message",
          tipo: "String",
          descripcion: "Mensaje de respuesta.",
        },
        {
          atributo: "status",
          tipo: "Boolean",
          descripcion: "Estado de la respuesta.",
        },
      ],

      responseHeadersData: [
        { key: "atributo", label: "atributo", isCode: true },
        { key: "tipo", label: "TIPO" },
        { key: "descripcion", label: "DESCRIPCIÓN" },
      ],

      responseObjectData: [
        {
          atributo: "id",
          tipo: "Integer",
          descripcion: "Identificador único de pago.",
        },
        {
          atributo: "estado",
          tipo: "String",
          descripcion: "Estado inicial del pago.",
        },
        {
          atributo: "description",
          tipo: "String",
          descripcion: "Descripción del cobro indicado.",
        },
        {
          atributo: "first_due_date",
          tipo: "String",
          descripcion: "Fecha de vencimiento.",
        },
        {
          atributo: "first_total",
          tipo: "Integer",
          descripcion: "Monto total antes de vencimiento.",
        },
        {
          atributo: "second_due_date",
          tipo: "String",
          descripcion: "Fecha límite de validez del cobro..",
        },
        {
          atributo: "second_total",
          tipo: "Integer",
          descripcion: "Monto total luego de vencimiento.",
        },
        {
          atributo: "payer_email",
          tipo: "String",
          descripcion: "Correo electrónico del pagador.",
        },
        {
          atributo: "external_reference",
          tipo: "String",
          descripcion:
            "Este atributo se puede utilizar como referencia para identificar la solicitud de pago y sincronizar con tus sistemas de backend el origen de la operación.",
        },
        {
          atributo: "metadata",
          tipo: "String",
          descripcion: "Información agregada para uso externo.",
        },
        {
          atributo: "uuid",
          tipo: "String",
          descripcion: "Identificador único de checkout.",
        },
        {
          atributo: "checkout_url",
          tipo: "String",
          descripcion: "Dirección web de acceso al checkout.",
        },
        {
          atributo: "created_at",
          tipo: "String",
          descripcion: "Fecha de creacion de la solicitud de pago.",
        },
        {
          atributo: "items",
          tipo: "Array [Object]",
          descripcion:
            "Objeto JSON que se puede utilizar para listar todos los productos o servicios asociados a la solicitud de pago, para que sean incluidos como un detalle del comprobante de pago.",
        },
      ],

      responseHeadersItems: [
        { key: "atributo", label: "atributo", isCode: true },
        { key: "tipo", label: "TIPO" },
        { key: "descripcion", label: "DESCRIPCIÓN" },
      ],

      responseObjectItems: [
        {
          atributo: "quantity",
          tipo: "Integer",
          descripcion: "Cantidad del producto o servicio.",
        },
        {
          atributo: "description",
          tipo: "String",
          descripcion: "Descripción del producto o servicio.",
        },
        {
          atributo: "amount",
          tipo: "Integer",
          descripcion: "Monto del producto o servicio.",
        },
        {
          atributo: "identifier",
          tipo: "String",
          descripcion: "Identificador del producto o servicio.",
        },
      ],

      // Ejemplos de código
      requestExample: `  [
       {
          "id": 859523,
          "estado_pago": "AUTORIZADO",
          "exito": true,
          "uuid": "1548fcf0-c855-44a3-b923-ce3857c6e8e3",
          "channel": "QR",
          "description": "PROBANDO NUEVA VERSION",
          "first_due_date": "2025-04-01T00:00:00Z",
          "first_total": 15.50,
          "second_due_date": "2025-04-01T00:00:00Z",
          "second_total": 15.70,
          "payer_name": "HIPOLITO CORONEL",
          "payer_email": "hipolito.coronel@telco.com.ar",
          "external_reference": "e0fda686-3265-43ce-9bec-10af238fcffe",
          "metadata": "",
          "barcode": "",
          "barcode_url": "",
          "pdf_url": "https://api-checkout.wee.ar/api/v1/checkout/bill/1548fcf0-c855-44a3-b923-ce3857c6e8e3",
          "created_at": "2025-04-01T15:00:09Z",
          "importe_pagado": 15.00
        }
       
      ]`,

      responseExample: `{
      "data": {
          "id": 578,
          "estado": "pending",
          "description": "Pago impuestos - DGR nueva prue 30062022",
          "first_due_date": "26-08-2022",
          "first_total": 15,
          "second_due_date": "30-08-2022",
          "second_total": 20,
          "payer_name": "juan gomez",
          "payer_email": "juan.gomez@telco.com.ar",
          "external_reference": "257370",
          "metadata": "",
          "uuid": "f930b9d5-2a54-4532-be33-1ec32b0b4afb",
          "checkout_url": "https://sb-wee.ar/v1/checkout/f930b9d5-2a54-4532-be33-1ec32b0b4afb",
          "pdf_url": "https://sb-wee.ar/v1/checkout/f930b9d5-2a54-4532-be33-1ec32b0b4afb",
          "created_at": "25-08-2022",
          "items": [
              {
              "quantity": 1,
              "description": "Pago de impuesto al sello",
              "amount": 10,
              "identifier": "11223344"
              },
              {
              "quantity": 1,
              "description": "Pago de impuesto al sello",
              "amount": 5,
              "identifier": "11223355"
              }
          ]
          },
          "message": "Solicitud de pago generada",
          "status": true
        }`,
    };
  },
};
</script>

<style scoped>
/* Responsive adjustments para el grid */
@media (max-width: 1279px) {
  .grid-cols-1.xl\:grid-cols-2 {
    grid-template-columns: 1fr;
  }
}
</style>
